import React from 'react';
import {
    DateInput,
    Create,
    SelectInput,
    TextInput,
    required,
    choices,
    TabbedForm,
    Toolbar,
    SaveButton,
    ListButton,
    CardActions,
    ImageInput,
    ImageField,
    FormTab,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import RegApprovedDonors from '../controls/RegApprovedDonors';
import ClearButton from '../controls/ClearButton'
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

const genderValues = [
    {
        id: 'Male',
        name: 'Male'
    },
    {
        id: 'Female',
        name: 'Female'
    },
    {
        id: 'Other',
        name: 'Other'
    }
]

export const styles = {

  hidden: {
    display: 'none'
  }
};

const validateGender = choices(['Male', 'Female','Other'], 'Must be Male, Female or Other');

const DonorCreateToolbar = props => (
    <Toolbar {...props} >
      {((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1) &&
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
      /> }
       <ClearButton />
    </Toolbar>
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const DonorCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);

const DonorCreate = ({ classes, ...props }) => (
<ErrorBoundary>
<Create {...props} actions={<DonorCreateActions />} >
      <TabbedForm  toolbar={<DonorCreateToolbar />}>
        <FormTab label="Identity" id="identity" >
            <RegApprovedDonors />
        </FormTab>
        <FormTab label="Allergies">
            <SanitizedTextInput source="allergies"   rowsMax={4} multiline fullWidth  label="Allergies"/>
        </FormTab>
        <FormTab label="Photo / ID">
            <lable>Donor photo (Add/Edit)</lable>
            <ImageInput source="pictures" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Donor" />
            </ImageInput>
            <lable>Donor photo (View)</lable>
            <ImageField source="photo_url" label="" />
            <br />
            <lable>Social Security Number proof (Add/Edit)</lable>
            <ImageInput source="photo_id_1" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="One" />
            </ImageInput>
            <lable>Social Security Number proof  (View)</lable>
            <ImageField source="photo_id_1_url" label="" />
            <br />
            <lable>Address proof (Add/Edit)</lable>
            <ImageInput source="photo_id_2" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Two" />
            </ImageInput>
            <lable>Address proof (View)</lable>
            <ImageField source="photo_id_2_url" label="" />
        </FormTab>
      </TabbedForm>
    </Create>
</ErrorBoundary>
);

export default withStyles(styles)(DonorCreate);
